// The shared half of every tool's table, zh-tw (machine-written, unread — ruling G4).
// Same leaves as en.js; composed under each tool's own table by compose() (@3dp/ui/i18n).
export const SHARED_ZH_TW = {
  back: "全部工具",   // the home link's word; its arrow is the template's (R70: at the phone layout the link shows the arrow alone, this word is its aria-label)
  text: "文字",
  font: "字型",
  dl3mf: "下載 3MF",
  share: "複製連結",
  updating: "計算中…",
  exportFail: "下載失敗",
  useFont: (family, mb) => `使用 ${family}（${mb} MB）`,
  pickFromList: "字型列表中的其他字型可能有這些字",   // R83: after the offered family, what it lacks — the list holds the others
  fontFailed: (family) => `無法載入 ${family}——請檢查網路連線 · 繼續使用目前字型`,
  fontNotOffered: (asked) => `此連結使用的字型 ${asked} 本頁沒有——改用 Kanit`,
  pick: "選擇 SVG 檔案",
  reading: "正在讀取檔案…",
  notSvg: "只支援 SVG 檔案——在 Illustrator 中選擇「轉存為 → SVG」，並先把文字轉為外框",
  svgTooBig: "檔案太大或太精細——請減少點數或合併形狀後重新轉出 SVG",
  svgEmpty: "此檔案中沒有填色形狀——請先把筆畫和文字轉為外框",
  svgBad: "此檔案無法讀取——不是可用的 SVG",
  readFail: "檔案無法讀取——請重新選擇",
  skipped: {
    background: (n) => `${n} 個背景——已移除`,
    bad: (n) => `${n} 個無法讀取的形狀——已略過`,
    clipped: (n) => `${n} 個帶剪裁遮罩的形狀——整個形狀被使用，不被裁切`,
    hidden: (n) => `${n} 個隱藏部分——未使用`,
    image: (n) => `${n} 個點陣圖——僅向量形狀可用`,
    stroke: (n) => `${n} 條無填色筆畫——請先轉成外框`,
    stroked: (n) => `${n} 個帶筆畫的形狀——筆畫寬度未計入`,
    text: (n) => `${n} 個文字元素——請先轉成外框`,
  },
  badLink: "此連結不可用——已改為開啟預設設計",
  newerLink: "此連結來自更新的版本——已改為開啟預設設計",
  buildFail: "計算失敗——請重新調整數值",
  lineHint: "在瀏覽器中開啟以下載",
  shareNoLogo: "此連結不含標誌檔案——開啟的人需要自行選擇 SVG",
  linkNeedsLogo: "此設計使用了檔案裡的標誌，但連結不含該檔案——請選擇 SVG 檔案補上",
  h: "高度（公厘）",
  numHint: (lo, hi) => `請輸入 ${lo}–${hi} 之間的數字`,
  percent: (v) => `${Math.round(v * 100)}%`,
  slot: (n) => `第 ${n} 槽`,
  parts: {
    lid: "蓋子",
  },
  fits: {
    loose: "寬鬆",
  },
  finishes: {
    engraved: "雕刻",
  },
  lookNames: {
    filasophy: "Filasophy",
  },
  viewGroup: "檢視",
  sources: {
    none: "無",
    svg: "SVG 檔案",
    text: "文字",
  },
  mood: {
    all: "全部",
    bold: "粗體",
    cute: "可愛",
    handwritten: "手寫",
    neat: "工整",
    tech: "科技",
  },
  problem: {
    "missing-chars": (p) => `此字型缺少這些字元：${p.chars.slice(0, 12).join(' ')}`,
    "text-too-complex": "文字太精細——請減少字元或換字型；無法下載",
  },
  noGl: "此瀏覽器無法顯示 3D，但仍可下載",
  needFileLine: "LINE 內無法下載——請先在瀏覽器中開啟本頁，再選擇檔案",
  undo: "復原",
  redo: "重做",
  machineNote: "機器翻譯，未經人工審校",   // shown by ja/zh pages only ("machine-written, unread")
  // ship 3 piece f (ruling R21): the language switch, its cannot-carry note, and the English-page offer
  langSwitchLabel: "語言",
  switchNoFile: "連結不含上傳的檔案——切換後需要重新選擇",
  offerLine: "用繁體中文查看本頁",
  offerDismiss: null,
  // the font control and the font sheet (@3dp/ui font-control.js, picker.js — unify-ui ship 4a, moved from name-tag)
  pickFont: "選擇字型",
  close: "關閉",
  weight: "字重",
  weightName: (w) => `${w} ${{ 100: '極細', 200: '特細', 300: '細體', 400: '常規', 500: '中等', 600: '半粗', 700: '粗體', 800: '特粗', 900: '極粗' }[w] || ''}`.trim(),
  scriptName: {
    latin: "拉丁",
    thai: "泰文",
    japanese: "日文",
    "chinese-simplified": "簡體中文",
    "chinese-traditional": "繁體中文",
    han: "中文/日文",
    other: "其他文字",
  },
  chipRemove: "顯示所有文字的字型",
  chipMark: "×",
  noFontForText: "沒有字型涵蓋這段文字——請換一種文字試試",
  noFontInMood: "此分組沒有字型",
  fontLoadFailed: "無法載入——請檢查網路連線",
  sample: {
    japanese: "名札",
    "chinese-simplified": "名牌",
    "chinese-traditional": "名牌",
  },
  moreFonts: "更多字型（Google Fonts）",
  backToCurated: "← 推薦字型",
  searchFonts: "搜尋字型",
  category: {
    all: "全部",
    "sans-serif": "無襯線",
    serif: "襯線",
    display: "顯示",
    handwriting: "手寫體",
    monospace: "等寬",
  },
  untested: "尚未列印測試",
  noFontFound: "沒有找到字型——請換個詞或分類試試",
  catalogLoading: "正在載入字型列表…",
  catalogFailed: "無法載入字型列表——請檢查網路連線",
  mb: (mib) => `${mib.toFixed(1)} MB`,
  // the colour control (@3dp/ui colours.js — unify-ui ship 4b, moved from name-tag): the own-colour input, an own colour's caption
  customColor: "自訂…",
  customCaption: "自訂",
};
